import { Box, styled } from '@mui/material';

export const MessageWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'navbarSpacerHeight',
})<{ navbarSpacerHeight?: number }>`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: ${({ navbarSpacerHeight = 0 }) => `calc(100vh - ${navbarSpacerHeight}px)`};
  padding: 15px;
  width: 100%;
`;
